// extracted by mini-css-extract-plugin
export var infoRow = "_uj-2";
export var labelContainer = "_uj-0";
export var rightInfo = "_uj-1";